


















import { Component, Mixins } from "vue-property-decorator";
import { NumberInput } from "../../../../../base/components/system";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { QrCodeStyle } from "../../../../domain/format/objects";

@Component({
  components: {
    OptionDropDownSelector,
    NumberInput,
  }
})

export default class QrCodeStyleEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: QrCodeStyle) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: QrCodeStyle) => T, defaultValue: T) => T;

  get cellSize(): number {
    return this.readPropertyOrDefault(s => s.cellSize, undefined);
  }

  set cellSize(value: number) {
    this.writePropertyWhenValid(s => s.cellSize = value);
  }

  get version(): number {
    return this.readPropertyOrDefault(s => s.version, undefined);
  }

  set version(value: number) {
    this.writePropertyWhenValid(s => s.version = value);
  }

  get calculatedTextNumber(): number {
    return this.version * 14;
  }

  cellSizeOptions: StandardOption<number>[] = [
    new StandardOption<number>("小", 2),
    new StandardOption<number>("中", 3),
    new StandardOption<number>("大", 4),
  ];
}
